module.exports = __webpack_public_path__ + "static/media/py2.3dc555f9.jpg";